export const demoRooms = {
  scandy: {
    kitchen: {
      id: 'CameraId1655312418182',
      cameraRotation: 0,
    },
    living: {
      id: 'CameraId1655312410663',
      cameraRotation: 4.3,
    },
    bathroom: {
      id: 'CameraId1655312467134',
      cameraRotation: 2,
    },
    bedroom: {
      id: 'CameraId1655312434494',
      cameraRotation: 1.5,
    },
  },
  england: {
    kitchen: {
      id: 'CameraID6f769ed0-7d05-4f88-a397-229ed7e42d02',
      cameraRotation: 0,
    },
    living: {
      id: 'CameraID140b49b6-4fe1-4d06-b803-1af10092d947',
      cameraRotation: 4.3,
    },
    bathroom: {
      id: 'CameraIDe967955c-088b-4526-bfcc-d8b95de52f55',
      cameraRotation: 2,
    },
    bedroom: {
      id: 'CameraID82fc46fc-3f72-4033-a3b9-15e3b8e9e2b8',
      cameraRotation: 1.5,
    },
  },
  boho: {
    kitchen: {
      id: 'CameraID6f769ed0-7d05-4f88-a397-229ed7e42d02',
      cameraRotation: 0.5,
    },
    living: {
      id: 'CameraID140b49b6-4fe1-4d06-b803-1af10092d947',
      cameraRotation: 4.3,
    },
    bathroom: {
      id: 'CameraIDe967955c-088b-4526-bfcc-d8b95de52f55',
      cameraRotation: 2,
    },
    bedroom: {
      id: 'CameraID82fc46fc-3f72-4033-a3b9-15e3b8e9e2b8',
      cameraRotation: 0,
    },
  },
  zero: {
    kitchen: {
      id: 'CameraId1655312418182',
      cameraRotation: 0,
    },
    living: {
      id: 'CameraId1655312410663',
      cameraRotation: 4.3,
    },
    bathroom: {
      id: 'CameraId1655312467134',
      cameraRotation: 2,
    },
    bedroom: {
      id: 'CameraId1655312434494',
      cameraRotation: 0,
    },
  },
  modern: {
    kitchen: {
      id: 'CameraId1655312418182',
      cameraRotation: 0,
    },
    living: {
      id: 'CameraId1655312410663',
      cameraRotation: 4.3,
    },
    bathroom: {
      id: 'CameraId1655312467134',
      cameraRotation: 2,
    },
    bedroom: {
      id: 'CameraId1655312434494',
      cameraRotation: 0,
    },
  },
  japandi: {
    living: {
      id: 'CameraID140b49b6-4fe1-4d06-b803-1af10092d947',
      cameraRotation: 4,
    },
    kitchen: {
      id: 'CameraID6f769ed0-7d05-4f88-a397-229ed7e42d02',
      cameraRotation: 0,
    },
    bathroom: {
      id: 'CameraIDe967955c-088b-4526-bfcc-d8b95de52f55',
      cameraRotation: 2,
    },
    bedroom: {
      id: 'CameraID82fc46fc-3f72-4033-a3b9-15e3b8e9e2b8',
      cameraRotation: 4.3,
    },
  },
  elegance: {
    living: {
      id: 'CameraPointIdecc03082-c59f-45ab-852a-26881faca0f3',
      cameraRotation: 2,
    },
    kitchen: {
      id: 'CameraPointId4401a503-3682-4683-a611-13d4f0583b0d',
      cameraRotation: 4.3,
    },
    bathroom: {
      id: 'CameraIDe967955c-088b-4526-bfcc-d8b95de52f55',
      cameraRotation: 0,
    },
    bedroom: {
      id: 'CameraID82fc46fc-3f72-4033-a3b9-15e3b8e9e2b8',
      cameraRotation: 4.3,
    },
  },
  american: {
    kitchen: {
      id: 'CameraPointIdbc8ac31c-6be0-4fb5-9f0f-238732d9bfb5',
      cameraRotation: 4.3,
    },
    living: {
      id: 'CameraIDaae728df-a49d-4d6a-8393-29fd937dd6a3',
      cameraRotation: 2,
    },
    bathroom: {
      id: 'CameraID97a50e12-eaee-4b73-9da5-cd9728e9af32',
      cameraRotation: 1,
    },
    bedroom: {
      id: 'CameraPointIde3a9df89-8db1-4181-a829-755a02ee30e4',
      cameraRotation: 2,
    },
  },
};
